/**
 * @prettier
 */
export const AppConfig = {
  role: ["viewerAdmin", "admin", "superAdmin"],
};
